import { DiagnosesSearchValueType } from '@src/api';

export const diagnosesSearchTypes = [
  { name: 'ICD-10', value: DiagnosesSearchValueType.ICD10 },
  { name: 'Diagnosis groups', value: DiagnosesSearchValueType.Groups },
];

export const defaultFilterValues = {
  search: '',
  skip: 0,
  take: 50,
};
